import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {Support} from "../../../shared/interface/support";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {Router} from "@angular/router";
import {AuthService} from "../../../shared/services/auth.service";
import {takeUntil} from "rxjs/operators";
import {CorporationService} from "../../../shared/services/corporation.service";
import {ConfirmDialogComponent} from "../../../shared/components/confirm-dialog/confirm-dialog.component";
import {HttpErrorResponse} from "@angular/common/http";
import {DICT_TYPE_SUPPORT_STATUS, DictService, SUPPORT_STATUS_DURING} from "../../../shared/services/dict.service";
import {Dictionary} from "../../../shared/interface/dictionary";

@Component({
  selector: 'app-corporation-details-view',
  templateUrl: './corporation-details-view.component.html',
  styleUrls: ['./corporation-details-view.component.scss']
})
export class CorporationDetailsViewComponent implements OnInit, OnDestroy {
  @Input() support: Observable<Support>;
  @Output() modifyClicked = new EventEmitter<any>();
  @Output() changed: EventEmitter<boolean> = new EventEmitter<boolean>();

  supportObject?: Support;
  userPermissions: ReplaySubject<UserPermissions>;
  dictionary: ReplaySubject<Dictionary>;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  constructor(
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private router: Router,
    private corporationService: CorporationService,
    private auth: AuthService,
    private dictService: DictService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.support
      .pipe(takeUntil(this.destroyed$))
      .subscribe((support: Support) => {
        this.supportObject = support;
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  modify(): void {
    this.modifyClicked.emit();
  }

  changeToDuringStatus(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz zmienić status na w toku?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.dictService.get(SUPPORT_STATUS_DURING, DICT_TYPE_SUPPORT_STATUS)
          .subscribe((dict: Dictionary) => {
            this.corporationService.changeStatus(
              this.supportObject.uuid,
              dict.id
            ).subscribe(() => {
              this.changed.emit();
              this.snack.open('Pomyślnie zmieniono status', '', {duration: 2000});
            }, (error: HttpErrorResponse) => {
              this.snack.open('Przy zmieniono status wystąpił błąd', error.status.toString(), {duration: 2000});
            });
          });
      }
    });
  }
}
